module.exports = __webpack_public_path__ + "static/media/hockey_icon-01.f15b4fc2.png";